import { EntityManager, EntityQuery, FilterQueryOp, Predicate } from 'breeze-client';
import { Customer } from '../model/customer';
import { Repository } from './repository';
import { Invoice } from '../model/entity-model';
export class CustomerRepository extends Repository<Customer> {
    constructor(manager: EntityManager) {
        super(manager, 'Customer', 'customers');
    }

    async getActiveCustomers(expand?: string, select?: string) {
        let query = this.baseQuery().where('deleted', '==', null).orderBy('firstName');
        if (!!expand) query = query.expand(expand);
        if (select) query = query.select(select);
        const data = await this.manager.executeQuery(query);
        return data.results as Customer[];
    }

    async getLookupCustomers() {
        const customers = (await this.getActiveCustomers(null, 'id, customerUnixKey, companyName')) as any[];
        return customers.map(customer => {
            return {
                id: customer.id,
                name: `${customer.customerUnixKey ?? ''} --- ${customer.companyName ?? ''}`
            }
        });
    }

    async search(filter: any, expand: string | string[], take?: number) {
        let query = this.baseQuery().expand(expand).where('deleted', '==', null).orderBy('companyName');
        if (take) query = query.take(take);
        if (filter.companyName) query = query.where('companyName', FilterQueryOp.Contains, filter.companyName);
        if (filter.firstName) query = query.where('firstName', FilterQueryOp.Contains, filter.firstName);
        if (filter.lastName) query = query.where('lastName', FilterQueryOp.Contains, filter.lastName);
        if (filter.billCity) query = query.where('billCity', FilterQueryOp.Contains, filter.billCity);
        const data = await this.manager.executeQuery(query);
        return data.results as Customer[];
    }

    async getProjects(expand?: string | string[], take?: number) {
        let predicate = new Predicate('deleted', '==', null)
        const query = EntityQuery.from('Projects').where(predicate).orderByDesc('created').expand(expand);
        const data = await this.manager.executeQuery(query);
        return data.results;
    }

    async getLoads(expand?: string | string[]) {
        let predicate = new Predicate('deleted', '==', null)
        let query = EntityQuery.from('GetNonInvoicedLoads').where(predicate).orderByDesc('created').expand(expand)
        const data = await this.manager.executeQuery(query);
        return data.results;
    }

    async getInvoices(customerId: number) {
        const predicate = new Predicate('deleted', '==', null).and('customerId', '==', customerId);
        const query = EntityQuery.from('Invoices').where(predicate).orderByDesc('created');
        const data = await this.manager.executeQuery(query);
        return data.results as Invoice[];
    }
}
